import { render, staticRenderFns } from "./add-department.vue?vue&type=template&id=7166e776&scoped=true&"
import script from "./add-department.vue?vue&type=script&lang=js&"
export * from "./add-department.vue?vue&type=script&lang=js&"
import style0 from "./add-department.vue?vue&type=style&index=0&id=7166e776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166e776",
  null
  
)

export default component.exports